if (typeof window !== "undefined") {
 window.tugEvalPromise =  new Promise(function (resolve) {
	if(window.__INITIAL_STATE__ && window.__INITIAL_STATE__.pagedata && window.__INITIAL_STATE__.pagedata.tugs && window.__INITIAL_STATE__.pagedata.tugs.length > 0 && !window.tugsEvaluated){
		const checkSponsor = () => {
			if(window.s_sponsor_program && window.s_sponsor_program.length > -1){
				return true;
			}
			return false;
		};
		const timeOutResolve = setTimeout(() => {
			resolve(checkSponsor());
		},10000);
		window.document.addEventListener('wbmd:tugsEvaluated', function() {
			resolve(checkSponsor());
			clearTimeout(timeOutResolve);
		}, {once:true});
	} else {
		let sponsorCheck = false;
		if(window.s_sponsor_program && window.s_sponsor_program.length > -1){
			sponsorCheck = true;
		}
		resolve(sponsorCheck);
	}
});
}


